const API_URL = process.env.REACT_APP_API_URL || 'https://linkedin-analyzer-backend-tg2l.onrender.com';

export const apiConfig = {
  baseURL: API_URL,
  endpoints: {
    parseSeparate: `${API_URL}/api/analysis/parse-separate`,
    generateMessage: `${API_URL}/api/messages/generate`,
    parsePost: `${API_URL}/api/analysis/parse-post`,
    parseEngagement: `${API_URL}/api/analysis/parse-engagement`
  }
};

console.log('API URL:', API_URL); // Für Debugging